(ns frontend.view.reports.custom.knight
  (:require
   [common.date-formats :as date-formats]
   [common.localization :as loc]
   [common.timezones :as timezones]
   [frontend.exports.excel :as excel]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.components.clipboard :as clipboard]
   [frontend.view.reports.custom.db :as db]
   [frontend.view.reports.custom.events :as events]
   [frontend.zap-time :as zap-time]
   [reagent.core :as r]
   [ui.components.card.view :as card]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.editors.data-input :as data-input]))

(defn report-view
  [column-labels data]
  (let [export-atom (atom [])
        _ (do
            (swap! export-atom conj (concat [""] column-labels))
            (doall (for [row-data data]
                     (swap! export-atom conj
                            (concat [(:label row-data)]
                                    (:data row-data))))))
        view-name [:span.d-inline-block.pr-2 (loc/tr :deals-per-stage-and-tags [(loc/tr :oppo/tag-phase)])]
        todays-date (date-formats/format-millis
                     (zap-time/now)
                     (or (:tenant/date-format @session/tenant) (loc/tr :date-format))
                     (or (:tenant/timezone @session/tenant) timezones/default-timezone))]
    [card/card
     [card/header
      [:div.d-flex.align-items-center
       [:span view-name]

       [:div.datepicker__wrapper
        [data-input/view
         {:data-type :data.type/date
          :value     (or (:timestamp @db/deals-per-tag-status-and-stage)
                         (.getTime (js/Date.)))
          :min-date  (some-> (:common/created-on @session/tenant)
                             (js/Date.))
          :on-change (fn [new-value]
                       (swap! db/deals-per-tag-status-and-stage assoc :timestamp new-value)
                       (events/load-deals-per-tag-status-and-stage))}]]]

      [:div.d-flex.justify-content-end
       [:i.fal.fa-copy.mr-3.pointer
        {:title    (loc/tr :copy-to-clipboard)
         :on-click (fn [_]
                     (clipboard/copy-as-tsv @export-atom))}]
       [:i.fal.fa-file-excel
        {:title    (loc/tr :save-as-excel)
         :on-click (fn [_]
                     (excel/export-array-data (loc/tr :export-filename-knight [todays-date])
                                              @export-atom))}]]]
     [card/body
      (if-not column-labels
        [:div.spinner-wrapper
         [:i.fal.fa-spinner.fa-pulse.fa-4x]
         (loc/tr :loading)]
        [:table.zap-simple-table.zap-simple-table--sm.w-100
         [:thead
          [:tr
           [:th
            ""]
           (doall (for [header column-labels]
                    [:th.col-heading
                     {:key (str "stage-vs-tags-report__heading-" header)}
                     header]))
           [:th
            (loc/tr :note)]]]
         (doall
          (->> data
               (map-indexed
                (fn [idx row-meta]
                  (let [row-data (:data row-meta)]
                    [:tbody
                     {:key        (str "stage-vs-tag-reports-row-" idx "-" (:label row-meta))
                      :class-name (fu/cs (cond (:stage row-meta) :per-stage
                                               (= :oppo.status/ok (:status row-meta)) :active
                                               (= :oppo.status/passed (:status row-meta)) :passed
                                               (= :oppo.status/on-hold (:status row-meta)) :on-hold
                                               )
                                         (when (:dropped-stages row-meta)
                                           (case (:dropped-stages row-meta)
                                             1 :post-first-stage
                                             2 :post-second-stage
                                             nil)))}
                     [:tr
                      [:td.row-heading
                       (:label row-meta)]
                      [:td.row-total-deals.number-value
                       (first row-data)]

                      (doall
                       (->> row-data
                            (rest)
                            (drop-last 2)
                            (map-indexed (fn [index col-value]
                                           [:td.number-value
                                            {:key (str "stage-vs-tag-reports-row-" (:label row-meta)
                                                       "->" index)}
                                            col-value]))))
                      [:td.no-tags.number-value
                       (->> row-data
                            (take-last 2)
                            (first))]


                      [:td.row-total-tags.number-value
                       (->> row-data
                            (last))]
                      [:td.duplicate-tags
                       (let [duplicate-oppo-ids (:duplicate-ids row-meta)]
                         (if (empty? duplicate-oppo-ids)
                           ""
                           [dropdown-menu/view
                            {:trigger
                             [:i.fal.fa-exclamation-circle {:aria-hidden true}]
                             :items (->> duplicate-oppo-ids
                                         (mapv (fn [dup]
                                                 (let [oppo (get @session/entities dup)]
                                                   {:label    [:span (loc/tr :duplicate-tags-in)
                                                               [:strong (:oppo/name oppo)]]
                                                    :on-click #(routing/open-entity dup)})))
                                         (doall))}]))]]])))
               (doall)))])]]))

(defn view
  [_]
  (let [phase-tag-attribute :oppo/tag-phase]
    (swap! db/deals-per-tag-status-and-stage
           assoc
           :loading true
           :tags-attribute phase-tag-attribute)
    (events/load-deals-per-tag-status-and-stage)
    (r/create-class
     {:reagent-render
      (fn [_]
        (let [{:keys [:tags-attribute :report :tags-attribute :loading]}
              @db/deals-per-tag-status-and-stage
              {:keys [:column-labels :data]} report]
          (if (= tags-attribute :none)
            [:div
             (loc/tr :this-report-only-works-with-phase-tags)]
            [:div.mb-4
             [report-view column-labels data]])))})))
